// Firebase Auth, Google sign-in — the web door's identity (Lore
// docs/designs/day-view.md §4). The `nefes-web` app's public config
// (Onur, 30.09.2026: the same app as nefesdilkonusma.com, so the day
// view can move under that domain later). authDomain stays the
// firebaseapp.com one: the popup handler lives there, and every origin
// the app is served from must be an authorized domain of the project.

import {initializeApp} from "firebase/app";
import {
  GoogleAuthProvider, browserLocalPersistence, getAuth,
  setPersistence, signInWithPopup, signOut,
} from "firebase/auth";

export const firebaseApp = initializeApp({
  apiKey: "AIzaSyC8C1ora4xU44_ZJewojMYC9jwh6C-VQMc",
  authDomain: "nefes-6c0ad.firebaseapp.com",
  projectId: "nefes-6c0ad",
  appId: "1:883764328056:web:21822dd1f77af3206f1f8d",
});

export const auth = getAuth(firebaseApp);
auth.languageCode = "tr";
// The desk computer stays signed in across days.
void setPersistence(auth, browserLocalPersistence);

export async function signInWithGoogle(): Promise<void> {
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({prompt: "select_account"});
  await signInWithPopup(auth, provider);
}

export function signOutEverywhere(): Promise<void> {
  return signOut(auth);
}

// Firebase's error codes, said the way the desk hears them.
export function signInErrorText(e: unknown): string {
  const code = (e as {code?: string} | null)?.code ?? "";
  switch (code) {
  case "auth/popup-blocked":
    return "Tarayıcı açılır pencereyi engelledi — bu site için izin verip tekrar deneyin.";
  case "auth/popup-closed-by-user":
  case "auth/cancelled-popup-request":
    return "Giriş penceresi kapandı — tekrar deneyin.";
  case "auth/unauthorized-domain":
    return "Bu adres Firebase'de yetkili alan değil — yöneticiye söyleyin.";
  case "auth/network-request-failed":
    return "Ağ hatası — bağlantıyı kontrol edip tekrar deneyin.";
  default:
    return "Giriş yapılamadı" + (code ? ` (${code})` : "") + ".";
  }
}
